export default "__VITE_ASSET__CnOavNNE__"